<template>
  <v-container>
    <v-row justify="space-between">
      <v-col
        cols="12" sm="6" md="8" lg="9"
        class="d-flex align-center title text-uppercase primary--text"
      >
        Actions
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-btn @click="openActionEditor('create')" block color="primary">
          {{ $t('actions.create') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-data-table
            :headers="actionsTable.headers"
            :items="actions"
            :loading="actionsTable.loading"
            item-key="id"
            :page="actionsPagination.page"
            :server-items-length="actionsPagination.total"
            :footer-props="{
              itemsPerPageOptions: actionsTable.itemsPerPageOptions
            }"
            @pagination="setPagination"
          >
            <template v-slot:item.actions="{ item }">
              <v-menu
                left
                offset-y
                nudge-bottom="10"
                transition="slide-y-transition"
                min-width="180px"
              >
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="openActionEditor('detail', item.id)">
                    Detalles
                  </v-list-item>
                  <v-list-item @click="openActionEditor('edit', item.id)">
                    Editar
                  </v-list-item>
                  <v-list-item @click="openActionRemove(item.id)">
                    Eliminar
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:no-data>
              <div class="text-center pa-12">
                <v-img
                  :src="require('@/assets/svg/box_empty.svg')"
                  height="150"
                  max-height="150px"
                  aspect-ratio="1"
                  contain
                />
                <div class="grey--text">
                  {{ $t('common.no_results_found') }}
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <ActionEditor />
    <ActionRemove />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ActionEditor from '@/components/Actions/Editor'
import ActionRemove from '@/components/Actions/Remove'
export default {
  components: {
    ActionEditor,
    ActionRemove
  },
  data () {
    return {
      actionsTable: {
        loading: false,
        headers: [
          {
            text: 'ID',
            value: 'id',
            align: 'end',
            class: 'blue--text text--darken-4 text-right text-no-wrap',
            width: '0'
          },
          {
            text: 'Name',
            value: 'name',
            align: 'start',
            class: 'blue--text text--darken-4 text-right text-no-wrap',
            width: ''
          },
          {
            text: 'Description',
            value: 'description',
            align: 'start',
            class: 'blue--text text--darken-4 text-right text-no-wrap',
            width: ''
          },
          {
            text: '',
            value: 'actions',
            align: 'center',
            class: '',
            sortable: false,
            width: '0'
          },
        ],
        itemsPerPageOptions: [
          { value: 5, text: 5 },
          { value: 10, text: 10 },
          { value: 15, text: 15 },
          { value: 25, text: 25 },
          { value: 100, text: 100 }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      actions: 'actions/actions',
      actionsPagination: 'actions/actionsPagination',
      updateRequired: 'actions/updateRequired'
    }),
    query () {
      return {
        fields: '',
        include: '',
        count: '',
        offset: '',
        limit: '',
        sort: '',
        filter: ''
      }
    }
  },
  watch: {
    updateRequired (newVal) {
      if (newVal) {
        this.getData()
      }
    }
  },
  created () {
    // this.getData()
  },
  destroyed () {
    this.resetState()
  },
  methods: {
    ...mapActions({
      resetState: 'actions/resetState',
      getActions: 'actions/getActions',
      getAction: 'actions/getAction'
    }),
    ...mapMutations({
      toggleUpdateRequired: 'actions/toggleUpdateRequired',
      toggleActionEditor: 'actions/toggleActionEditor',
      toggleActionRemove: 'actions/toggleActionRemove',
      setActionEditorMode: 'actions/setActionEditorMode',
      setActionsPagination: 'actions/setActionsPagination'
    }),
    async getData () {
      const {
        limit,
        offset
      } = this.actionsPagination
      this.actionsTable.loading = true
      await this.getActions({
        limit,
        offset
      })
      this.actionsTable.loading = false
    },
    setPagination (pagination) {
      const {
        itemsPerPage,
        page
      } = pagination
      this.setActionsPagination({
        ...this.actionsPagination,
        limit: itemsPerPage,
        offset: page
      })
      this.getData()
    },
    async openActionEditor (mode = 'create', id) {
      if (['edit', 'detail'].includes(mode)) {
        await this.getAction({ id })
      }
      this.setActionEditorMode(mode)
      this.toggleActionEditor(true)
    },
    async openActionRemove (id) {
      await this.getAction({ id })
      this.toggleActionRemove(true)
    }
  }
}
</script>
